import React, { useEffect, useState } from 'react'
import Hubnav from '../Hubnav'
import axios from 'axios'
import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
const AllotDeliveryBoy = () => {
    const [search,setSeach]=useState("")
    const location=useLocation()
    var nav = useNavigate()
//     const [orders,setorders]=useState()
//     async function getOrderDetails(props) {
//       const r = await axios.get(`http://localhost:8082/getAllOrdersByHub?name=${props}`, { headers: { "Authorization": "Bearer " + sessionStorage.getItem("pic") } })
//       setorders(r.data)
//   }
       const searchProduct=()=> {
        var nodes = document.getElementsByClassName('target');
        var i
        for (i = 0; i < nodes.length; i++) {
          var str=search.toLowerCase()
          if (nodes[i].innerText.toLowerCase().includes(str)) {
             if(nodes[i].style.display==="none")
                 nodes[i].style=''
          } else {
            nodes[i].style.display = "none";
          }
        }
      }

    //   function updateDB(props){
    //     axios.post(`http://localhost:8082/UpdateDeliveryBoy?orderno=${location.state.orderno}&name=${props}`,{},{headers: { "Authorization": "Bearer " + sessionStorage.getItem("pic") } })
    //     alert("Delivery Boy Alloted")
    //     products.map((data) => (<>
    //     {
    //         axios.post(`http://localhost:8082/OutForDelivery?id=${data.ordernumber}&pid=${data.product_id}`,{},{headers: { "Authorization": "Bearer " + sessionStorage.getItem("pic") } })
            
    //     }
    //     </>))
    //     nav(-1)
    //   }

      const [boys,setBoys]=useState()
      const getBoys = async () => {
        const response = await axios.get(`http://localhost:8082/GetDeliveryBoys?name=${sessionStorage.getItem("user")}`,{ headers: { "Authorization": "Bearer " + sessionStorage.getItem("pic") } })  
          setBoys(response.data)
        }
        useEffect(() => {
          getBoys();
        }, []);  
      useEffect(() => {
        searchProduct()
   },[search])
  return (
    <>
    <Hubnav/>
    <div className=''>
            <input id='search' className="searchUser" type="text" placeholder="Search for Delivery boy with name, pincode etc" name="search" value={search} 
            onChange={(e)=>setSeach(e.target.value)}/>
    </div>
    <div className="row row-cols-lg-4 row row-cols-md-3 row-cols-sm-1 h-100 w-100 p-5 mx-auto">
            {boys
            ? boys.map((data,key) => (
                
                <div key={key} className="col singleCard card target py-5" id={data.couponCode}>
                <div className="col card-body text-center">
                    <h4>{data.name}</h4>
                    <h6>Delivery Pincode: {data.deliverypincode}</h6>
                    <button className='btn btn-success rmv'>Allot Delivery Boy</button>
                    </div>
                </div>
                

            )):""}
             </div>
    </>
  )
}

export default AllotDeliveryBoy